export default "__VITE_ASSET__45523a63__"